module.exports = __webpack_public_path__ + "img/intelligent_recognition.347aeead.png";